import { render, staticRenderFns } from "./finalizado.vue?vue&type=template&id=14f98adb&scoped=true"
import script from "./finalizado.vue?vue&type=script&lang=js"
export * from "./finalizado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f98adb",
  null
  
)

export default component.exports